// src/components/Navbar/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faHeart, faTimes, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';

import styles from './Navbar.module.css';

const Navbar = ({ isNavOpen, toggleNav, isFavoritesOpen, toggleFavorites, closeMenus, favorites, removeFavorite }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navLinks = [
    { id: "accueil", text: "ACCUEIL" },
    { id: "menu-formules", text: "MENU" },
    { id: "poke-bowls", text: "POKE BOWLS" },
    { id: "sushis", text: "SUSHIS" },
    { id: "accompagnements-entrees", text: "ENTRÉES" },
    { id: "nos-plateaux", text: "PLATEAUX" },
    { id: "plats", text: "PLATS" },
    { id: "specialites", text: "SPÉCIALITÉS" },
    { id: "vapeurs", text: "VAPEURS" },
    { id: "desserts", text: "DESSERTS" },
    { id: "boissons", text: "BOISSONS" },
    { id: "commander-par-telephone", text: "COMMANDER" },
    { id: "contact", text: "CONTACT" },
  ];

  const calculateTotal = () => {
    return favorites.reduce((sum, item) => {
      const price = parseFloat(item.price.replace('€', '').replace(',', '.'));
      return sum + (isNaN(price) ? 0 : price);
    }, 0).toFixed(2);
  };

  const totalFavoritesPrice = calculateTotal();
  
  const getPath = (id) => (id === "accueil" ? "/" : `/${id}`);

  return (
    <nav className={`${styles.navbar} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.container}>
        <button className={styles.burgerIcon} onClick={toggleNav} aria-label="Ouvrir le menu de navigation">
          <FontAwesomeIcon icon={faBars} />
        </button>

        <Link to="/" onClick={closeMenus} className={styles.logoLink}> 
          <img src="/images/logo1.png" alt="Le Poké" className={styles.navbarTitleImage} /> 
        </Link>

        <ul className={styles.navLinksDesktop}>
          {navLinks.map((link) => (
            <li key={link.id}>
              <Link to={getPath(link.id)} onClick={closeMenus}>{link.text}</Link>
            </li>
          ))}
        </ul>

        <div className={styles.rightIcons}>
          {/* <-- LIEN MIS A JOUR ICI (1/2) --> */}
          <a href="https://www.facebook.com/profile.php?id=100070239904930" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Page Facebook">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <button className={styles.favoriteIcon} onClick={toggleFavorites} aria-label="Ouvrir les favoris">
            <FontAwesomeIcon icon={faHeart} />
            {favorites.length > 0 && <span className={styles.favoriteCount}>{favorites.length}</span>}
          </button>
        </div>

        <div className={`${styles.navOverlay} ${isNavOpen ? styles.navOpen : ''}`}>
          <button className={styles.closeNav} onClick={toggleNav} aria-label="Fermer le menu de navigation">
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <ul className={styles.navLinksMobile}>
            {navLinks.map((link) => (
              <li key={link.id}>
                <Link to={getPath(link.id)} onClick={closeMenus}>{link.text}</Link>
              </li>
            ))}
            <li className={styles.navMobileSeparator}></li>
            <li>
              {/* <-- LIEN MIS A JOUR ICI (2/2) --> */}
              <a href="https://www.facebook.com/profile.php?id=100070239904930" target="_blank" rel="noopener noreferrer" className={styles.socialIconMobile}>
                <FontAwesomeIcon icon={faFacebookF} /> Suivez-nous sur Facebook
              </a>
            </li>
          </ul>
        </div>

        <div className={`${styles.favoritesPanel} ${isFavoritesOpen ? styles.favoritesOpen : ''}`}>
          <button className={styles.closeFavorites} onClick={toggleFavorites} aria-label="Fermer les favoris">
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <h3 className={styles.favoritesTitle}>Vos Favoris ({favorites.length})</h3>
          
          {favorites.length === 0 ? (
            <p className={styles.favoritesMessage}>Votre liste de favoris est vide.</p>
          ) : (
            <>
              <ul className={styles.favoritesList}>
                {favorites.map((item) => (
                  <li key={item.id} className={styles.favoriteItem}>
                    <div className={styles.favoriteItemDetails}>
                      <span className={styles.favoriteItemName}>{item.name}</span>
                      <span className={styles.favoriteItemPrice}>{item.price}</span>
                    </div>
                    <button onClick={() => removeFavorite(item.id)} className={styles.removeFavoriteButton} aria-label={`Retirer ${item.name} des favoris`}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </li>
                ))}
              </ul>
              <div className={styles.favoritesSummary}>
                <div className={styles.totalPrice}>
                  <span>Total :</span>
                  <span>{totalFavoritesPrice}€</span>
                </div>
                <Link 
                  to="/commander-par-telephone" 
                  className={styles.orderButton}
                  onClick={closeMenus}
                >
                  <FontAwesomeIcon icon={faPhoneAlt} /> Commander
                </Link>
              </div>
            </>
          )}
        </div>

        {(isNavOpen || isFavoritesOpen) && (
          <div className={styles.backdrop} onClick={closeMenus}></div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;